import { useThemeVariant } from "@/contexts/ThemeContext";
import { useServicesModel } from "@/components/home/layouts/models";
import { ClassicServices } from "@/components/home/layouts/classic";
import { MinimalServices } from "@/components/home/layouts/minimal";
import { WarmServices } from "@/components/home/layouts/warm";
import { BoldServices } from "@/components/home/layouts/bold";
import { ElegantServices } from "@/components/home/layouts/elegant";
import { FreshServices } from "@/components/home/layouts/fresh";
import { ModernServices } from "@/components/home/layouts/modern";

/**
 * Homepage services. Cards are driven by the active service categories so the
 * homepage stays in sync with the Services tab; the composition (photo cards,
 * numbered list, zig-zag rows, menu, bento…) follows the theme preset.
 */
export function Services() {
  const s = useServicesModel();
  const variant = useThemeVariant();

  // Don't render if there are no active service categories to show
  if (!s.loading && s.items.length === 0) return null;

  switch (variant) {
    case "modern-minimal": return <MinimalServices s={s} />;
    case "warm-welcome": return <WarmServices s={s} />;
    case "bold-vibrant": return <BoldServices s={s} />;
    case "elegant-serif": return <ElegantServices s={s} />;
    case "fresh-natural": return <FreshServices s={s} />;
    case "modern": return <ModernServices s={s} />;
    default: return <ClassicServices s={s} />;
  }
}
